import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=50b1ea0e&"
import script from "./Personnel.vue?vue&type=script&lang=js&"
export * from "./Personnel.vue?vue&type=script&lang=js&"
import style0 from "./Personnel.vue?vue&type=style&index=0&id=50b1ea0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports